import {PriceModel} from '../Price.model';
import {AdditionalFee as AdditionalFeeV1} from '@wix/auto_sdk_ecom_current-cart';
import {V2AdditionalFee as AdditionalFee} from '@wix/auto_sdk_ecom_cart-v-2';
import {ModelContext} from '../../../types/app.types';

export class FeeModel {
  public code: string;
  public name: string;
  public price: PriceModel;

  constructor(params: FeeModel) {
    this.code = params.code;
    this.name = params.name;
    this.price = params.price;
  }

  public static fromCartV1(fee: AdditionalFeeV1, modelContext: ModelContext) {
    return new FeeModel({
      code: fee.code,
      name: fee.translatedName ?? fee.name,
      price: PriceModel.fromCartV1(fee.price, modelContext),
    });
  }

  public static fromCartV2(fee: AdditionalFee, modelContext: ModelContext): FeeModel {
    return new FeeModel({
      code: fee.code,
      name: fee.name?.translated ?? fee.name?.original ?? /* istanbul ignore next */ '',
      price: PriceModel.fromCartV2(fee.price, modelContext),
    });
  }
}
